import { Component, OnInit } from '@angular/core';
import { ChartData, ChartOptions } from 'chart.js';
import { creFadeInOut } from 'cre-ng';
import dayjs from 'dayjs';

import { User } from '@app/core/core.model';
import { FleetCompetitionDetailDto } from '@app/core/driver-wig.model';
import { IDriverWigService } from '@app/core/services/interface/IDriverWigService';
import { ServiceFactory } from '@app/core/services/service.factory';
import { AuthService } from '@app/core/auth.service';

@Component({
  animations: [creFadeInOut],
  selector: 'app-wig-fleet-competition-trend',
  styleUrls: ['./wig-fleet-competition-trend.component.css'],
  templateUrl: './wig-fleet-competition-trend.component.html',
})
export class WigFleetCompetitionTrendComponent implements OnInit {
  battleTitle: string;
  chartData: ChartData;
  chartOptions: ChartOptions;
  driverWigService: IDriverWigService;
  fleet: string;
  hasData: boolean;
  isDataLoaded = false;

  private currentUser: User;

  constructor(private authService: AuthService, serviceFactory: ServiceFactory) {
    this.driverWigService = serviceFactory.getDriverWigService();
  }

  ngOnInit() {
    this.chartOptions = {
      legend: {
        display: false,
      },
      scales: {
        xAxes: [
          {
            gridLines: {
              display: false,
            },
          },
        ],
        yAxes: [
          {
            gridLines: {
              display: false,
            },
          },
        ],
      },
      tooltips: {
        enabled: false,
      },
    };

    this.currentUser = this.authService.getCurrentUser();

    void this.driverWigService.getFleetWeekly(this.currentUser.username).then((fleetWeekly) => {
      this.battleTitle =
        fleetWeekly != null
          ? fleetWeekly.battles.length > 0
            ? fleetWeekly.battles[0].graphTitle
            : ''
          : '';
      this.fleet = fleetWeekly != null ? fleetWeekly.fleet : null;

      this.driverWigService
        .getFleetCompetitionDetails(this.fleet)
        .then((data) => {
          this.buildChartData(data);
        })
        .finally(() => {
          this.isDataLoaded = true;
        });
    });
  }

  private buildChartData(data: FleetCompetitionDetailDto[]) {
    const fleetScoreData: number[] = [];
    const goalData: number[] = [];
    const labels = [];

    data.forEach((fleetCompetitionDetail) => {
      fleetScoreData.push(
        fleetCompetitionDetail.hasCompData ? fleetCompetitionDetail.competition : null
      );
      goalData.push(fleetCompetitionDetail.goalValue);
      labels.push(dayjs(fleetCompetitionDetail.weekStart).format('M-D'));
    });

    if (data.length === 0) {
      this.chartOptions.scales.yAxes[0].ticks = {
        min: 0,
        max: 100,
      };
      this.hasData = false;
    } else {
      this.hasData = true;
    }

    this.chartData = {
      datasets: [
        {
          borderColor: '#b32026',
          borderWidth: 1,
          data: fleetScoreData,
          fill: false,
          lineTension: 0,
        },
        {
          backgroundColor: '#ffffff',
          borderColor: '#c2c2c2',
          borderWidth: 1,
          data: goalData,
          fill: true,
          lineTension: 0,
        },
      ],
      labels,
    };
  }
}
